<template>
  <v-col class="purchase-report">
    <div class="d-flex justify-space-between">
      <div class="text-h5 cl-primary">Laporan Belanja Produk</div>
    </div>
    <div class="pt-1 pb-2 d-flex font-size-10 grey--text">
      <v-icon small color="grey">mdi-storefront</v-icon>
      <div class="pl-2">Agen Area</div>
      <div class="px-2">/</div>
      <div>Laporan Belanja Produk</div>
    </div>
    <div class="mt-5">
      <v-row>
        <v-col cols="12" class="py-0 py-sm-3">
          <div class="d-flex justify-end">
            <v-btn
              depressed
              color="primary"
              class="white--text rounded-lg text-capitalize"
              @click="showSearch"
            >
              <div class="d-flex">
                <v-icon small class="d-block d-sm-none">mdi-magnify</v-icon>
                <div class="d-none d-sm-block">Cari</div>
              </div>
            </v-btn>
            <v-btn
              depressed
              color="grey lighten-1"
              class="ml-3 white--text rounded-lg text-capitalize"
              @click="reset"
              >Reset</v-btn
            >
          </div>
        </v-col>
      </v-row>

      <v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
        <div class="mt-5" v-if="!loading">
          <v-row v-if="listTransaction.length > 0">
            <v-col cols="12" class="pt-0">
              <v-simple-table class="white-row table-vo table-history-bonus">
                <template v-slot:default>
                  <thead class="">
                    <tr>
                      <th class="text-left" width="15%">Kode Transaksi</th>
                      <th class="text-left" width="15%">Tanggal</th>
                      <th class="text-left" width="30%">Nama Pemesan</th>
                      <th class="text-left" width="25%">Item Order</th>
                      <th class="text-center" width="10%">Status</th>
                    </tr>
                  </thead>
                  <tbody class="grey--text text--darken-3">
                    <tr
                      v-for="transaction in listTransaction"
                      :key="transaction.transaction_id"
                    >
                      <!-- <td class="text-left">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class=""
                              fab
                              dark
                              x-small
                              depressed
                              color="primary"
                              v-bind="attrs"
                              v-on="on"
                              @click.stop="getDetail(transaction.transaction_id)"
                            >
                              <v-icon dark>mdi-text-box-search</v-icon>
                            </v-btn>
                          </template>
                          <span>Detail</span>
                        </v-tooltip>
                      </td> -->
                      <td class="text-left font-weight-bold primary--text">
                        {{ transaction.agent_order_code }}
                      </td>
                      <td class="text-left">
                        {{ transaction.agent_order_date | tanggal }}
                      </td>
                      <td class="text-left">
                        <div class="font-weight-bold">
                          {{ transaction.agent_order_name }}
                        </div>
                        <small class="d-block text-muted">
                          {{ transaction.agent_order_address }}
                        </small>
                      </td>
                      <td class="text-left">
                        <small class="d-block text-muted">
                          {{ transaction.agent_order_product_type }}
                        </small>
                        <div>
                          <b>Size : {{ transaction.agent_order_product_size }}</b>
                        </div>
                      </td>
                      <td class="text-center text-capitalize">
                        <v-chip
                          small
                          :color="
                            getTransactionStatus(transaction.agent_order_status).color
                          "
                          class="font-weight-bold white--text text-uppercase"
                          >{{
                            getTransactionStatus(transaction.agent_order_status).label
                          }}</v-chip
                        >
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
          <div class="mt-3" v-if="listTransaction.length == 0">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-card class="py-3 elevation-0 hover-shadow rounded-lg">
                  <NoData></NoData>
                  <div class="pt-3 text-center cl-secondary">
                    Tidak ada list transaksi yang dapat ditampilkan
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </div>
          <div v-if="listTransaction.length > 0">
            <v-row justify="end">
              <v-col
                cols="12"
                sm="5"
                md="6"
                class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end"
              >
                <v-pagination
                  v-model="pageAll"
                  total-visible="5"
                  class="d-flex justify-end vo-pagination no-button-focus"
                  color="primary"
                  :length="transactionPagination.total_page"
                  @input="changePageAll"
                ></v-pagination>
              </v-col>
              <v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
                <div class="font-size-10">
                  Menampilkan {{ transactionPagination.total_display }} data dari total
                  {{ transactionPagination.total_data }} data
                </div>
              </v-col>
              <v-col cols="4" sm="2" md="1">
                <v-autocomplete
                  :items="listLimit"
                  v-model="limit"
                  hide-details
                  dense
                  class=""
                  placeholder="Data"
                  color="primary"
                  @input="changeLimitAll"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-scroll-x-reverse-transition>
      <div class="mt-4" v-if="loading">
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <LoadData :loading="loading"></LoadData>
          </v-col>
        </v-row>
      </div>
    </div>
    <ModalSearchReport ref="modalSearchReport" @action="cari"></ModalSearchReport>
    <ModalDetail ref="modalDetail"></ModalDetail>
  </v-col>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ModalSearchReport from "./components/ModalSearchReport";
import ModalDetail from "./components/ModalDetail";

export default {
  components: {
    ModalSearchReport,
    ModalDetail,
  },
  data() {
    return {
      loading: false,
      currentTabs: 0,
      pageAll: 1,
      pageWait: 1,
      limit: "10",
      listLimit: ["10", "20", "50", "100"],
      params: [],
      transactionStatus: [
        {
          status: "sukses",
          color: "success",
          label: "Sukses",
          icon: "mdi-check-decagram-outline",
        },
        {
          status: "approved",
          color: "success",
          label: "Disetujui",
          icon: "mdi-check-decagram-outline",
        },
        {
          status: "menunggu",
          color: "warning",
          label: "Menunggu",
          icon: "mdi-timer-sand",
        },
        {
          status: "pending",
          color: "warning",
          label: "Menunggu",
          icon: "mdi-timer-sand",
        },
        {
          status: "rejected",
          color: "error",
          label: "Ditolak",
          icon: "mdi-close-circle-outline",
        },
      ],
    };
  },
  computed: {
    ...mapState("masterAgen", ["listTransaction", "transactionPagination"]),
  },
  methods: {
    ...mapActions("masterAgen", ["getListTransaction"]),

    getTransactionStatus(status) {
      const transaction = this.transactionStatus.find((x) => x.status === status);
      if (transaction) {
        return transaction;
      } else {
        const nontransaction = {
          status: "",
          color: "secondary",
          label: "",
          icon: "",
        };
        return nontransaction;
      }
    },

    async getDataAll() {
      this.loading = await true;
      this.getListTransaction(
        this.queryString({
          sort: "agent_order_date",
          dir: "DESC",
          limit: this.limit,
          page: this.pageAll,
          params: this.params,
        })
      ).then(() => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.loading = false;
      });
    },

    getDetail(id) {
      this.$refs.modalDetail.modalShow(id);
    },
    changePageAll(page) {
      this.pageAll = page;
      this.getDataAll();
    },
    changeLimitAll(limit) {
      this.limit = limit;
      this.pageAll = 1;
      this.getDataAll();
    },
    showSearch() {
      this.$refs.modalSearchReport.modalShow();
    },
    reset() {
      this.params = [];
      this.pageAll = 1;
      this.getDataAll();
      this.$refs.modalSearchReport.reset();
    },
    cari(data) {
      this.params = [];
      this.pageAll = 1;
      this.currentTabs = 0;
      this.waitingReport = false;

      if (data.kode.value) this.params.push(data.kode);
      if (data.name.value) this.params.push(data.name);
      if (data.date.value) this.params.push(data.date);
      if (data.status.value) this.params.push(data.status);
      this.getListTransaction(
        this.queryString({
          sort: "agent_order_date",
          dir: "DESC",
          limit: this.limit,
          page: this.page,
          params: this.params,
        })
      ).then(() => {
        this.$refs.modalSearchReport.modalHide();
      });
    },
  },
  async created() {
    const isAgenUser = await localStorage.getItem("isAgenUser");
    if (isAgenUser !== "true") this.$router.push({ name: "dashboard" });

    await this.$store.dispatch("setPageTitle", `Laporan Belanja Produk`);
    await this.getDataAll();
  },
};
</script>
